.composer {
  flex: 0 0 auto;
  border: 1px solid var(--hcr-line-primary-color);
  border-radius: var(--hcr-primary-border-radius);
  padding: var(--hcr-spacing-3);
  display: flex;
  flex-direction: column;
  gap: var(--hcr-spacing-2);
}

.composerChips {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-wrap: wrap;
  gap: var(--hcr-spacing-1);
}

.composerChip {
  display: inline-flex;
  align-items: center;
  gap: var(--hcr-spacing-1);
  // Tight right padding — the chip's remove (×) button sits on that edge; normal
  // spacing on the left.
  padding: var(--hcr-spacing-1) var(--hcr-spacing-1) var(--hcr-spacing-1)
    var(--hcr-spacing-2);
  border: 1px solid var(--hcr-line-primary-color);
  border-radius: var(--hcr-primary-border-radius);
  background-color: var(--hcr-box-bg-color);
  font-size: var(--hcr-font-size-small);
  max-width: 100%;
}

.composerChipName {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.composerInput {
  border: none;
  resize: none;
  min-height: var(--hcr-spacing-8);
  padding: 0;

  &:focus,
  &:focus-visible {
    box-shadow: none;
    outline: none;
  }
}

.composerActions {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.hiddenFileInput {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}
